<template>
  <div class="of-box">
    <div class="of-container is-vertical">
      <div class="of-aside base-search-box">
        <div class="of-filter clearfix">
          <div class="filter-left">
            <el-button v-access:export type="primary" size="small" icon="fa fa-cloud-download"
              :loading="exportLoading" @click="exportTap()">导出</el-button>
          </div>
          <div class="filter-right">
            <div style="margin-top: 3%;">
              周期:{{pageQuery.StartTime.substring(0,10)}}至{{pageQuery.EndTime.substring(0,10)}}</div>
            <el-popover ref="popoverDom" placement="bottom-start" width="320"
              popper-class="el_popover_class" trigger="click">
              <div>
                <div>
                  <el-form label-width="80px" :model="pageQuery" class="search-form">
                    <el-form-item label="项目" class="search-form-item">
                      <el-select v-model="pageQuery.ProjectId" placeholder="请选择" filterable
                        size="small">
                        <el-option label="请选择" value=""></el-option>
                        <el-option v-for="item in proList" :key="item.Id" :label="item.Name"
                          :value="item.Id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="服务对象" class="search-form-item">
                      <el-select v-model="pageQuery.ServiceId" placeholder="请选择" filterable
                        size="small">
                        <el-option label="请选择" value=""></el-option>
                        <el-option v-for="item in serList" :key="item.Id" :label="item.Name"
                          :value="item.Id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="时间" size="small" class="search-form-item">
                      <el-date-picker v-model="pageQuery.year" style=" width:100%" type="year"
                        placeholder="选择年" @change="changeYear">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="查询维度" size="small" class="search-form-item">
                      <datePicker :value="values" ref="datePickRef" @change="setTimeChange">
                      </datePicker>
                    </el-form-item>
                    <el-form-item label="关键字" class="search-form-item">
                      <el-input v-model="pageQuery.fastSearchKeyWord" placeholder="业务" size="small"
                        clearable prefix-icon="fa fa-search"></el-input>
                    </el-form-item>
                    <div class="btns" style="text-align: left;padding-top: 5px;">
                      <el-button type="primary" size="small" @click="search">查 询</el-button>
                      <el-button type="primary" size="small" @click="resetsSearch">重 置</el-button>
                    </div>
                  </el-form>
                </div>

              </div>
              <el-button size="small" style="margin-left:10px;" slot="reference"
                icon="el-icon-search">
                高级搜索</el-button>
            </el-popover>
          </div>
        </div>
      </div>
      <div ref="tableBox" class="of-main no-scroll">
        <div class="of-table">
          <el-table v-loading="isloading" border stripe resizable :data="listData"
            style="width: 100%" size="small" :max-height="pageHeight" show-summary
            :height="pageHeight" :header-cell-style="{ background: '#f2f3f5' }" tooltip-effect>
            <el-table-column type="index" label="序号" width="50">
              <template slot-scope="scope">
                <span v-if="scope.row['MainName'].indexOf('合计') != -1"></span>
                <span v-else>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column v-for="(item, index) in tableCols" :key="index" :prop="item.prop"
              :label="item.label" :width="item.width" header-align="left" :align="item.align">

              <template slot-scope="scope">
                <el-tooltip v-if="item.showtip" :content="`${scope.row[item.prop]}`"
                  placement="bottom" effect="light">
                  <span>{{ scope.row[item.prop] }}</span>
                </el-tooltip>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
      <div class="of-aside">
        <my-pagination :total="total" :pageSize="pageQuery.pageSize"
          :pageIndex="pageQuery.pageIndex" @change="pageChange"></my-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { demandReportList, exportReportList } from '@/modules/contract/api/freightReport.js'
import MyPagination from "@/components/pagination"
import { getBaseSearchOptsHasIsolation } from '@/modules/report/api/baseSearch'
import datePicker from '@/modules/report/components/dateCascader'
export default {
  name: 'DModelPage',
  components: {
    MyPagination,
    datePicker
  },
  props: {

  },
  data () {
    return {
      pageQuery: {
        pageSize: 50,
        pageIndex: 1,
        sortOrder: 'desc',
        sortField: 'ServiceId',
        fastSearchFields: 'ServiceName,TowVehicleName',
        fastSearchKeyWord: '',
        ServiceId: '',
        year: '',
        StartTime: '',
        EndTime: '',
        DateType: '',
        DateValue: '',
        ReportType: "业务"
      },
      detailshow: false,
      pageHeight: 500,
      total: 0,
      myForm: {
        title: "新增轮胎",
        form: {},
      },
      tableCols: [
        { label: '业务', prop: 'MainName', width: '150', type: '', sortable: true, showtip: true },
        { label: '开始日期', prop: 'DateS', width: '100', type: '', sortable: true, showtip: true },
        { label: '结束日期', prop: 'DateE', width: '100', type: '', sortable: true, showtip: true },
        { label: '趟次合计', prop: 'TrainNumStr', width: '', type: '', sortable: true, showtip: true },
        { label: '装货数量', prop: 'LoadQtyStr', width: '', type: '', sortable: true, showtip: true },
        { label: '卸货数据', prop: 'UnLoadQtyStr', width: '', type: '', sortable: true, showtip: true },
        { label: '路线收入', prop: 'InAttrVal1Str', width: '', type: '', sortable: true, showtip: true },
        { label: '合计', prop: 'ALLStr', width: '', type: '', sortable: true, showtip: true },

      ],
      isSubmit: false,
      editshow: false,
      isloading: false,
      listData: [],
      exportLoading: false,
      hjRow: null,
      tbCols: [],
      otherCols: [],
      serList: [],
      proList: []
    }

  },
  computed: {

  },
  created () {
    let mouth = this.moment().month()
    this.pageQuery.year = `${this.moment().year()}`
    let times = new Array()
    times[0] = 'month'
    times[1] = `${mouth}`
    this.values = [...times]
    this.setTimeChange(times)
  },
  mounted () {
    getBaseSearchOptsHasIsolation().then(rsp => {

      if (rsp.data.Code == 0) {
        this.serList = rsp.data.Data.ServiceList
        this.proList = rsp.data.Data.AllProList
      }
    })
    this.loadPageData()
    this.mixinTableHeight()
  },
  methods: {
    loadPageData () {
      this.isloading = true
      demandReportList(this.pageQuery).then(res => {
        this.isloading = false
        if (res.data.Code === 0) {
          this.listData = res.data.Data
          this.total = res.data.Data.length
        }
      })
    },
    pageChange (pindex, psize) {
      this.pageQuery.pageSize = psize
      this.pageQuery.pageIndex = pindex
      this.loadPageData()
    },
    exportTap () {
      this.exportLoading = true
      exportReportList({ ...this.pageQuery }).then(res => {
        this.exportLoading = false
        if (res.data.Code == 0) {
          window.open(
            `/common/CommonTemplateDown/DownExportFileTitle?title=业务运费详情${this.datetime(new Date(), 'YYYYDDMM')}&&id=${res.data.Data}`
          )
        }
      })
    },
    resetsSearch () {
      this.pageQuery.fastSearchKeyWord = ''
      this.pageQuery.ServiceId = ''
      this.pageQuery.ProjectId = ''
      let mouth = this.moment().month()
      this.pageQuery.year = `${this.moment().year()}`
      let times = new Array()
      times[0] = 'month'
      times[1] = `${mouth}`
      this.setTimeChange(times)
      this.$refs.datePickRef.init()
      this.search()
    },
    search () {
      this.pageQuery.pageIndex = 1
      this.listData = []
      this.loadPageData()
      this.$refs.popoverDom.doClose()
    },
    setTimeChange (times) {
      this.$set(this.pageQuery, 'DateType', times[0])
      this.$set(this.pageQuery, 'DateValue', times[1])
      let thisyear = this.pageQuery.year
      switch (this.pageQuery.DateType) {
        case "month":
          var mouth = parseInt(this.pageQuery.DateValue == '0' ? '1' : this.pageQuery.DateValue)
          this.pageQuery.StartTime = this.datetime(this.moment(`${thisyear}/${mouth}/01`).startOf('day')) // new Date(thisyear, mouth, "01")
          this.pageQuery.EndTime = this.datetime(this.moment(`${thisyear}/${mouth}/01`).endOf("month"))
          break
        case "quarter":
          //0,3,6,9
          var quarter = parseInt(this.pageQuery.DateValue)
          this.pageQuery.StartTime = this.datetime(this.moment().year(thisyear).quarter(quarter).startOf('quarter'))
          this.pageQuery.EndTime = this.datetime(this.moment().year(thisyear).quarter(quarter).endOf('quarter'))
          break
        case "halfyear":
          var mouth2 = parseInt(this.pageQuery.DateValue == '1' ? '1' : '7')
          this.pageQuery.StartTime = this.datetime(this.moment(`${thisyear}/${mouth2}/01`).startOf('day')) // new Date(thisyear, mouth, "01")
          this.pageQuery.EndTime = this.datetime(this.moment(`${thisyear}/${mouth2 * 1 + 5}/01`).endOf("month"))
          break
        default:
          this.pageQuery.StartTime = this.datetime(this.moment().year(thisyear).startOf('year'))
          this.pageQuery.EndTime = this.datetime(this.moment().year(thisyear).endOf('year'))
      }
    },
    changeYear (t) {
      this.$set(this.pageQuery, 'year', `${this.moment(t).year()}`)
      let times = new Array()
      times[0] = this.pageQuery.DateType
      times[1] = this.pageQuery.DateValue
      this.setTimeChange(times)
    },
    setbottomFixed (params) {
      const { row, rowIndex } = params
      row.index = rowIndex
      // 最后三行固定
      if (rowIndex + 1 == this.listData.length) {
        return `tr-fixed fixed-row`
      }
      return ''
    },
  }
}
</script>

<style></style>
